$(document).ready(function () {
    const $slider = $('.images-container-on-mobile');
    let slickInitialized = false;
    const $lightbox = $('.lightbox');
    let lightboxInitialized = false;
    const $lightboxContainer = $('#rolex-lightbox-gallery');

    function isSlickDefined($el) {
        return $el.hasClass('slick-initialized');
    }

    function handleSlider() {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        if (isMobile && !slickInitialized) {
            $slider.slick({
                slidesToShow: 1,
                dots: true,
                arrows: false
            });
            slickInitialized = true;
        } else if (!isMobile && slickInitialized && isSlickDefined($slider)) {
            $slider.slick('unslick');
            slickInitialized = false;
        }
    }

    function handleLightbox() {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        if (!isMobile && !lightboxInitialized) {
            $lightbox.slick({
                slidesToShow: 1,
                dots: true,
                arrows: true
            });
            slickInitialized = true;

            // duplicate header to move it to the lightbox
            let $rolexHeaderContainer = $('.rolex-header-container');
            if($rolexHeaderContainer.length > 0) {
                let $rolexHeaderClone = $rolexHeaderContainer.clone();
                $rolexHeaderClone.addClass('header-clone');
                $lightboxContainer.prepend($rolexHeaderClone);
            }

            toggleRolexLightbox();
        } else if (isMobile && lightboxInitialized && isSlickDefined($slider)) {
            $lightbox.slick('unslick');
            lightboxInitialized = false;
        }
    }

    function toggleRolexLightbox() {
        let $slides = $('div[data-role="rolex-lightbox"]');
        let $closeButton = $('.lightbox-close');

        $slides.on('click', function () {
            let $this = $(this);
            let index = $this.data('rolex-lightbox');
            $lightbox.slick('slickGoTo', index);
            $lightboxContainer.addClass('active');
            $('body').addClass('rolex-lightbox-open');
        });

        $closeButton.on('click', function () {
            $lightboxContainer.removeClass('active');
            $('body').removeClass('rolex-lightbox-open');
        });
    }

    handleLightbox();
    handleSlider();

    $(window).on('resize', function () {
        handleSlider();
        handleLightbox();
    });
});
